import {GoogleLogin} from '@react-oauth/google';
import {Navigate, useNavigate} from 'react-router-dom';
import Layout from '../Layout';
import {isLoggedIn, login} from '../api';

export default function LoginPage() {
    const navigate = useNavigate();

    if (isLoggedIn()) return <Navigate to="/" replace/>;

    function onSuccess(credentialResponse) {
        login(credentialResponse.credential)
            .then(() => navigate('/'))
            .catch((err) => {
                console.error(err);
                alert('Errore dati utente, ritenta il login ed in caso di problemi contatta ict@noberasco.it');
            });
    }

    return (
        <Layout>
            <div className="d-flex justify-content-center mt-5">
                <div className="card text-center" style={{width: 360}}>
                    <div className="card-body p-4">
                        <h1 className="titolo-pagina">Noberasco 1908</h1>
                        <p className="text-secondary">Accedi con il tuo account Google Noberasco.</p>
                        <div className="d-flex justify-content-center">
                            <GoogleLogin onSuccess={onSuccess} onError={() => alert('Login Google non riuscito')}/>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
